import * as THREE from 'three';

const HEIGHT = 75;
const WIDTH = 150;
const DEPTH = 20;

const DRAG = 0.5;

export default class Player extends THREE.Mesh {
  constructor (position, colour) {
    const paddleMaterial = new THREE.MeshLambertMaterial({color: colour});
    super(new THREE.BoxGeometry(WIDTH, HEIGHT, DEPTH), paddleMaterial);

    this.position.x = position.x;
    this.position.y = position.y;
    this.position.z = position.z;

    this.width = WIDTH;
    this.height = HEIGHT;
    this.depth = DEPTH;

    this.castShadow = true;
    this.velocity = new THREE.Vector3(0,0,0);
    //
    // const orbitalGeom = new THREE.SphereGeometry(8);
    // const orbitalMat = new THREE.MeshLambertMaterial({color: 0x00FFAA});
    // this.orbital = new THREE.Mesh(orbitalGeom, orbitalMat);
    // this.orbital.castShadow = true;
    // this.add(this.orbital);
    // this.orbital.position.set(0, 0, - DEPTH - 64);
    //
    // this.orbital2 = new THREE.Mesh(orbitalGeom, orbitalMat);
    // this.orbital2.castShadow = true;
    // this.add(this.orbital2);
    // this.orbital2.position.set(-DEPTH + 10, 0, 0);
  }

  update (t) {
    if (this.velocity.x !== 0) {
      this.position.x += this.velocity.x;
      this.velocity.x += (this.velocity.x > 0 ? -DRAG : DRAG);
    }

    if (this.velocity.z !== 0) {
      this.position.z += this.velocity.z;
      this.velocity.z += (this.velocity.z > 0 ? -DRAG : DRAG);
    }
    // if (this.velocity.y !== 0) {
    //   this.position.y += this.velocity.y;
    //   this.velocity.y += (this.velocity.y > 0 ? -DRAG : DRAG);
    //   if (this.bottom < 0 || this.top > 200) {
    //     this.position.y = previousY;
    //   }
    // }

    // this.orbital.position.set(0, Math.cos(5 * t) * -(DEPTH+64), Math.sin(5 * t) * -(DEPTH+64));
    // this.orbital2.position.set(Math.sin(5 * t) * -(DEPTH + 10), Math.cos(5 * t) * -(DEPTH+64), 0);

    // this.rotation.x += 0.05;
    // this.rotation.y += 0.05;
    // this.rotation.z += 0.05;
  }

  get front () {
    return this.position.z + (DEPTH / 2);
  }

  get back () {
    return this.position.z - (DEPTH / 2);
  }

  get top () {
    return this.position.y + (HEIGHT / 2);
  }

  get bottom () {
    return this.position.y - (HEIGHT / 2);
  }

  get left () {
    return this.position.x - (WIDTH / 2);
  }

  get right () {
    return this.position.x + (WIDTH / 2);
  }
}



// WEBPACK FOOTER //
// ./src/entities/player.js